import { Ordinal as OrdinalScale } from '@antv/scale';
export const Ordinal = (options) => {
    return new OrdinalScale(options);
};
Ordinal.props = {};
//# sourceMappingURL=ordinal.js.map